module.exports = __webpack_public_path__ + "static/media/puppy.f462d937.jpg";